import { Navigate } from 'react-router-dom';

import { useAuth, authStatus } from '../../../context/auth/AuthContext';
import OverLayLoader from '../../OverLayLoader';

const ProtectedRoute = ({ children }) => {
  const { status } = useAuth();

  if (status === authStatus.LOADING) {
    return <OverLayLoader />;
  }

  if (status === authStatus.UNAUTHENTICATED) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
